import { Badge, type BadgeColor } from '@design/components/badge/Badge';
import clsx from 'clsx';

import styles from './GradientCard.module.scss';

export type GradientCardAccent = 'success' | 'error' | 'warning';

export interface GradientCardProps {
  /** Short label shown beside the tag in the meta row. */
  eyebrow: string;
  /** Primary text content. */
  body: string;
  /** Secondary line below the body section. */
  footnote: string;
  /** Label for the outline tag in the meta row. */
  tagLabel: string;
  /** Color treatment for the tag. */
  tagColor: BadgeColor;
  /** Left-to-right gradient accent on the card surface. */
  accent?: GradientCardAccent;
  /** Extra class forwarded to the root element. */
  className?: string;
}

export const GradientCard = ({
  eyebrow,
  body,
  footnote,
  tagLabel,
  tagColor,
  accent = 'success',
  className,
}: GradientCardProps) => {
  return (
    <div
      className={clsx(styles.root, className, {
        [styles.accentSuccess]: accent === 'success',
        [styles.accentError]: accent === 'error',
        [styles.accentWarning]: accent === 'warning',
      })}
    >
      <div className={styles.bodySection}>
        <div className={styles.metaRow}>
          <span className={styles.eyebrow}>{eyebrow}</span>
          <Badge
            color={tagColor}
            size="xsmall"
            badgeStyle="outline"
            label={tagLabel}
          />
        </div>
        <p className={styles.body}>{body}</p>
      </div>
      <p className={styles.footnote}>{footnote}</p>
    </div>
  );
};
